import { useRef, useEffect } from 'react';
import paper from 'paper';

// Grid of lines that bend toward a phantom cursor tracing a slow path.
// Segment positions are reset each frame from stored originals so the
// deformation stays bounded and oscillates rather than accumulating.
const CrumplePreview = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    paper.setup(canvasRef.current);
    const w = paper.view.size.width;
    const h = paper.view.size.height;

    const cols = 9, rows = 9;
    const spacingX = w / (cols - 1);
    const spacingY = h / (rows - 1);

    const palette = ['blue', 'red', 'black', 'red', 'blue', 'black', 'red', 'blue', 'black'];
    const curves = [];
    const initPos = [];

    for (let i = 0; i < rows; i++) {
      const curve = new paper.Path();
      curve.strokeColor = palette[i % palette.length];
      curve.strokeWidth = 2;
      const row = [];
      for (let j = 0; j < cols; j++) {
        const x = j * spacingX;
        const y = i * spacingY;
        curve.add(new paper.Point(x, y));
        row.push({ x, y });
      }
      curves.push(curve);
      initPos.push(row);
    }

    const onFrame = () => {
      const t = Date.now() * 0.002;
      const mx = w / 2 + Math.sin(t * 1.1) * w * 0.45;
      const my = h / 2 + Math.sin(t * 0.7) * h * 0.45;
      const mp = new paper.Point(mx, my);

      curves.forEach((curve, ci) => {
        curve.segments.forEach((seg, si) => {
          seg.point.x = initPos[ci][si].x;
          seg.point.y = initPos[ci][si].y;
          const dist = seg.point.getDistance(mp);
          const bend = 220 / (dist + 1);
          const dir = seg.point.subtract(mp).normalize();
          seg.point = seg.point.subtract(dir.multiply(bend));
        });
      });
    };

    paper.view.on('frame', onFrame);
    return () => { paper.view.off('frame', onFrame); paper.project.clear(); };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%', backgroundColor: 'white' }} />;
};

export default CrumplePreview;
